import { createRoutine } from 'redux-saga-routines';

export const fetchSurveys = createRoutine('FETCH_SURVEYS');
export const fetchSurveyById = createRoutine('FETCH_SURVEY_BY_ID');
export const deactivateSurvey = createRoutine('DEACTIVATE_SURVEY');
export const fetchSurveyResponses = createRoutine('FETCH_SURVEY_RESPONSES');
export const deleteSurveyResponse = createRoutine('DELETE_SURVEY_RESPONSE');
export const bookmarkSurvey = createRoutine('BOOKMARK_SURVEY_RESPONSE');
export const fetchSurveyResponsesByEntity = createRoutine(
  'FETCH_SURVEY_RESPONSE_BY_ENTITY'
);
export const fetchSurveyStatBarData = createRoutine(
  'FETCH_SURVEY_STAT_BAR_DATA'
);

export const resetSurveyResponsesAndStatBar = createRoutine(
  'RESET_SURVEY_RESPONSES_AND_STAT_BAR'
);

export const createSurvey = createRoutine('CREATE_SURVEY');
export const editSurvey = createRoutine('EDIT_SURVEY');
export const editSurveyStatus = createRoutine('EDIT_SURVEY_STATUS');
export const publishSurvey = createRoutine('PUBLISH_SURVEY');
export const sendSurveyEmail = createRoutine('SEND_SURVEY_EMAIL');
export const verifySurveyInstallation = createRoutine(
  'VERIFY_SURVEY_INSTALLATION'
);

export const deleteSurvey = createRoutine('DELETE_SURVEY');

export const fetchSurveyEmailDomain = createRoutine(
  'FETCH_SURVEY_EMAIL_DOMAIN'
);
